<template>
  <section
    class="message-section custom-section"
    @dragover.prevent="onDragOver"
    @dragenter.prevent="onDragEnter"
    @dragleave="onDragLeave"
    @drop="handleFileDrop"
  >

    <div class="custom-typing">{{ typingMessage }}</div>
    <div
      id="chatMessages"
      class="content message-list"
    >
      <chat-message
        v-for="(msg, idx) of messages"
        :key="idx"
        :message="msg"
        :lastmessage="LastMessage(idx)"
        :id="msg.messageId"
        :isHistory="isHistory"
        @image-clicked="openImageModal"
      />
    </div>
    <div
      v-if="isDragging && isChatFileUploadEnabled"
      class="drop-overlay"
    >
      <p>{{ $t('dialog.chat.dropfile') }}</p>
    </div>

    <div class="new-message" v-show="!isHistory">
      <textarea
        v-model="message"
        @keyup="userTyping"
        ref="messageInput"
      />
      <div class="send-message">
        <a href="#" @click="SendMessage" title="Send">
          <i class="far fa-paper-plane"></i>
        </a>
        <button v-if="isChatFileUploadEnabled" class="upload-button-icon" @click="triggerFileInput" :title="$t('dialog.button.tooltip.upload')">
          <i class="fas fa-paperclip"></i>
        </button>
        <input v-if="isChatFileUploadEnabled" type="file" ref="fileInput" @change="handleFileSelect" style="display: none" />
      </div>
    </div>

    <!-- Fullscreen Image Modal -->
    <transition name="fade">
      <div
        v-if="imageModalVisible"
        class="modal-overlay"
        @click.self="closeImageModal"
      >
        <button class="modal-close" @click="closeImageModal">×</button>
        <img
          v-if="isImage(selectedImageUrl)"
          :src="selectedImageUrl"
          class="modal-image"
        />
        <video
          v-else
          class="modal-video"
          controls
          autoplay
          :src="selectedImageUrl"
        >
          <source v-if="message.type === 'video/mp4'" :src="selectedImageUrl" type="video/mp4" />
          <source v-if="message.type === 'video/webm'" :src="selectedImageUrl" type="video/webm" />
          <source v-if="message.type === 'video/ogg'" :src="selectedImageUrl" type="video/ogg" />
          {{ $t('dialog.chat.video.error') }}
        </video>
      </div>
    </transition>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ChatMessage from './chat-message'
import sendbird from '@/store/modules/chat/sendbird.js'
import globals from '@/plugins/globals.js'
export default {
  name: 'chat',
  components: {
    ChatMessage
  },
  props: {
    isHistory: Boolean
  },
  data() {
    return {
      messages1: [],
      message: '',
      typingMessage: '',
      waitTimeout: null,
      isDragging: false,
      imageModalVisible: false,
      selectedImageUrl: ''
    }
  },
  watch: {
    isTyping() {
      if (this.isTyping) {
        this.typingMessage = 'someone is typing...'
      } else {
        this.typingMessage = ''
      }
    },
    messages() {
      let $this = this
      if (this.messages !== undefined && this.messages != null) {
        if (this.messages.length > 0) {
          setTimeout(function() {
            var element = $this.$el.querySelector('#chatMessages')
            element.scrollTop = element.scrollHeight - element.clientHeight
          }, 300)
        }
      }
    }
  },
  mounted() {},
  computed: {
    ...mapGetters('sendbird', ['messages', 'isTyping']),
    isChatFileUploadEnabled() {
      console.log(`DEBUG => isChatFileUploadEnabled: ${globals.isChatFileUploadEnabled()}`)
      return globals.isChatFileUploadEnabled()
    }
  },
  methods: {
    ...mapActions('sendbird', ['addMessageToList']),
    userTyping(e) {
      window.clearTimeout(this.waitTimeout)
      sendbird.channel.startTyping()
      this.waitTimeout = window.setTimeout(() => {
        sendbird.channel.endTyping()
      }, 1500)
      if (e.keyCode === 13) {
        if (e.ctrlKey) {
          // this.message += '\n'
        } else {
          e.preventDefault()
          this.SendMessage()
        }
      }
    },
    userEntered(e) {
      console.log('Enter was pressed', e)
    },
    LastMessage(idx) {
      let message = null
      if (idx > 1) {
        message = this.messages[idx - 1]
      }
      return message
    },
    SendMessage() {
      try {
        let $this = this
        // var msg = this.message.replace(/\n/g, '<br>').trim()
        // // send the message
        sendbird.sendMessage(this.message, sentMessage => {
          this.addMessageToList(sentMessage)
          setTimeout(function() {
            var element = $this.$el.querySelector('#chatMessages')
            element.scrollTop = element.scrollHeight - element.clientHeight
          }, 300)
        })
        this.message = ''
      } catch (e) {
        console.log('Error (sendChat)', e)
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    onDragEnter() {
      if (this.isChatFileUploadEnabled) {
        this.isDragging = true
      }
    },
    onDragOver(event) {
      if (this.isChatFileUploadEnabled) {
        event.preventDefault()
        this.isDragging = true // Ensure state stays active
      }
    },
    onDragLeave() {
      if (this.isChatFileUploadEnabled) {
        this.isDragging = false
      }
    },
    handleFileDrop(event) {
      if (this.isChatFileUploadEnabled) {
        event.preventDefault()
        event.stopPropagation()
        this.isDragging = false
        if (event.dataTransfer && event.dataTransfer.files.length > 0) {
          const file = event.dataTransfer.files[0]

          if (file) {
            this.uploadFile(file)
          }
        } else {
          console.warn(this.$t('dialog.chat.file.error'))
        }
      }
    },
    handleFileSelect(event) {
      const file = event.target.files[0]
      if (file) {
        this.uploadFile(file)
      }
    },
    uploadFile(file) {
      if (file) {
        // Handle file upload logic here
        sendbird.uploadFile(file)
      }
    },
    openImageModal(url) {
      this.selectedImageUrl = url
      this.imageModalVisible = true
    },
    closeImageModal() {
      this.imageModalVisible = false
      this.selectedImageUrl = ''
    },
    isImage(url) {
      return /\.(jpeg|jpg|gif|png|bmp)$/i.test(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.message-list {
  min-height: 340px;
  height: 340px;
  padding: 4px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.new-message {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: #fff;
  border-top: 1px solid #ccc;
  box-sizing: border-box;
  width: 100%;
}

.new-message textarea {
  flex-grow: 1;
  min-height: 40px;
  max-height: 100px;
  resize: vertical;
  padding: 8px;
  font-size: 14px;
  line-height: 1.4;
  border-radius: 5px;
  border: 1px solid #ccc;
  overflow-y: auto;
  box-sizing: border-box;
}

.send-message {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 40px;
  gap: 10px;
}

.send-message a,
.send-message button {
  background: none;
  border: none;
  padding: 0;
  font-size: 18px;
  cursor: pointer;
  color: #007bff;
}

.upload-button-icon {
  font-size: 20px;
  background: none;
  border: none;
  cursor: pointer;
  color: #007bff;
  padding: 5px;
  align-items: center;
  justify-content: center;
}

.send-message a:hover,
.upload-button-icon:hover {
  color: #0056b3;
}
.custom-section {
  position: relative;
}
.custom-typing {
  position: absolute;
  top: -15px;
  width: 100%;
  text-align: center;
  font-size: 0.7em;
  font-weight: 500;
  // background-color: yellow;
}
.drop-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 123, 255, 0.1);
  border: 2px dashed #007bff;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #007bff;
  font-size: 1.2em;
  pointer-events: none; // important to not block underlying drop events
}
button {
  background: none;
  border: none;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-image {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0,0,0,0.5);
}
.modal-close {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 2rem;
  color: #fff;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 10000;
}

.modal-close:hover {
  color: #ccc;
}
.modal-video {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0,0,0,0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/chat/chat.vue